import {
  createRootRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";

import { CommandMenuProvider } from "../components/command-menu/command-menu";
import { GlobalShortcuts } from "../components/command-menu/global-shortcuts";
import { MenuBar } from "../components/os/menu-bar";
import { StatusBar } from "../components/os/status-bar";
import { TerminalTabsProvider } from "../components/terminal/tabs-store";

export const Route = createRootRoute({
  component: RootLayout,
});

/**
 * Surfaces that own the whole viewport (the terminal) render flush under the
 * menu bar; every other page keeps scrollable, padded content.
 */
function isFullBleed(pathname: string): boolean {
  return pathname === "/" || pathname.startsWith("/terminal");
}

/**
 * The OS frame: a fixed top menu bar, a single scrolling main region, and a
 * fixed bottom status bar. The terminal fills `main`; other surfaces scroll.
 */
function RootLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const fullBleed = isFullBleed(pathname);

  return (
    <CommandMenuProvider>
      <TerminalTabsProvider>
        <GlobalShortcuts />
        <div className="flex h-dvh w-full flex-col overflow-hidden bg-background text-foreground antialiased">
          <MenuBar />
          <main
            className={
              fullBleed
                ? "min-h-0 flex-1 overflow-hidden"
                : "min-h-0 flex-1 overflow-y-auto px-6 py-8"
            }
          >
            <Outlet />
          </main>
          <StatusBar />
        </div>
      </TerminalTabsProvider>
    </CommandMenuProvider>
  );
}
